// extracted by mini-css-extract-plugin
module.exports = {"strawberrySection":"page404_strawberrySection__9hx2m","ordersBtn":"page404_ordersBtn__3oCaf"};